export function init(view){
	//parsing initial data
	view.attachEvent("onDataParse", (data) => _parse(view, data));
	view.attachEvent("onDataSerialize", (data, config) => _serialize(view, data, config));

	// undo
	view.attachEvent("onUndo", (type, row, column, value) => {
		if(type == "value")
			_undoValue(view, row, column, value);
	});
}

function _serialize(view, obj, config){
	var math = !config || config.math!==false;

	var grid = view.$$("cells");
	var state = grid.getState();
	var columns = state.ids.concat(state.hidden);

	// remove "rowId" column
	columns.splice(columns.indexOf("rowId"), 1);

	[obj.data, obj.locked] = getSheetData(view, math);

	webix.extend(
		obj.table,
		{
			frozenColumns : (view._frozenColumns || 0),
			frozenRows : (view._frozenRows || 0)
		}
	);
}

function _parse(view, obj){
	const tconfig = obj.table || {};
	view._frozenColumns = view._frozenRows = 0;
	view.freezeColumns(tconfig.frozenColumns || 0);
	view.freezeRows(tconfig.frozenRows || 0);

	if(obj.sizes)
		view.$$("cells").define("fixedRowHeight", false);
}

function _undoValue(view, row, column, value){
	view.setCellValue(row, column, value);
}

export function getSheetData(view, math, page){
	page = page ? view._mData.getPage(page) : view._mPage;
	const locked = [];
	return [
		page.serialize(math)
			.map(arr =>{
				if(arr[2].$locked)
					locked.push([arr[0]+1, arr[1]+1]);
				let value = arr[2].value;
				if(value === null)
					value = "";
				return [ ++arr[0], ++arr[1], value, arr[2].style||"", arr[2].type];
			})
			.filter(arr => {
				return arr[2] || arr[2] === 0 || arr[3];
			}),
		locked
	];
}